module.exports = __webpack_public_path__ + "img/picnic.9b40d1a6.svg";